module.exports = __webpack_public_path__ + "static/img/shuju.9865cf24.png";